export const updateModal = (state, action) => {
    state.playerModal = {
        ...action.payload
    };
};
